import {
  Stack,
  Dialog,
  Button,
  Typography,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@mui/material';

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  alertText: string | React.ReactNode;
  title?: string;
  closeButtonText?: string;
  submitButtonText?: string;
  isLoading?: boolean;
}

export const AlertModal = ({
  open,
  onClose,
  onSubmit,
  alertText,
  title,
  isLoading,
  closeButtonText = 'Отмена',
  submitButtonText = 'Принять',
}: Props) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    fullWidth
    slotProps={{
      paper: {
        sx: { bgcolor: 'background.paper', borderRadius: '14px' },
      },
    }}
  >
    {title && <DialogTitle>{title}</DialogTitle>}
    <DialogContent>
      <Typography variant="body1">{alertText}</Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 3 }}>
      <Stack direction="row" gap={2} justifyContent="end" width="100%">
        <Button onClick={onSubmit} variant="contained" autoFocus fullWidth loading={isLoading}>
          {submitButtonText}
        </Button>
        <Button onClick={onClose} variant="outlined" fullWidth>
          {closeButtonText}
        </Button>
      </Stack>
    </DialogActions>
  </Dialog>
);
